import { render, staticRenderFns } from "./NavList.vue?vue&type=template&id=66e5da48&scoped=true"
import script from "./NavList.vue?vue&type=script&lang=js"
export * from "./NavList.vue?vue&type=script&lang=js"
import style0 from "./NavList.vue?vue&type=style&index=0&id=66e5da48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5da48",
  null
  
)

export default component.exports